import { useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import { METHOD_LOGIN_KEY } from "../../features/auth/config/authRoutes";
import { sendCbidIdentity } from "../../shared/lib/attribution/sendCbidIdentity";
import use123zapStore from "../../stores/123zapStore";

export default function SessionBootstrap({ children }) {
  const { isAuthenticated, user } = useAuth();
  const loadPlanoAtual = use123zapStore((state) => state.loadPlanoAtual);
  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";
  const isProfileComplete = String(user?.completeProfile).toLowerCase() === "true";
  const canLoadPrivateContext =
    isAuthenticated && isEmailVerified && isProfileComplete && Boolean(user?.accountId);

  useEffect(() => {
    if (canLoadPrivateContext) {
      loadPlanoAtual(true);
    }
  }, [canLoadPrivateContext, loadPlanoAtual]);

  /* Vínculo `cbid` ↔ cliente logado (fase 3 do B4, spec 0121 do
   * `briotecnologia/123zap-site-automation`).
   *
   * Este é o ponto certo por uma razão que não é óbvia: a guarda acima já
   * exige `accountId`, e o `accountId` só existe DEPOIS da seleção de conta.
   * Enviar de dentro do `useLoginForm` mandaria conta ambígua para quem tem
   * mais de uma — e a relação pessoa↔conta é muitos-para-muitos. */
  useEffect(() => {
    if (!canLoadPrivateContext) return;

    let methodLogin = null;
    try {
      methodLogin = window.sessionStorage.getItem(METHOD_LOGIN_KEY);
    } catch {
      methodLogin = null;
    }

    sendCbidIdentity({
      accountId: user?.accountId,
      email: user?.email,
      methodLogin,
    });
  }, [canLoadPrivateContext, user?.accountId, user?.email]);

  return children;
}
